import { Label, Select, Checkbox } from '@/components/ui'
import { useValuationStore } from '@/store/valuationStore'

const garageOptions = [
  { value: 'box', label: 'Box auto' },
  { value: 'posto_auto', label: 'Posto auto' },
]

export function ServicesStep() {
  const { formData, updateFormData } = useValuationStore()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Servizi e accessori</h2>
        <p className="mt-1 text-gray-600">
          Indica i servizi aggiuntivi dell'immobile
        </p>
      </div>

      <div className="space-y-6">
        {/* Pertinenza */}
        <div className="p-4 border border-gray-200 rounded-lg">
          <Checkbox
            id="hasPertinenza"
            checked={formData.hasPertinenza || false}
            onChange={(e) => updateFormData({ hasPertinenza: e.target.checked })}
            label="Pertinenza (cantina, soffitta, posto auto coperto)"
          />
        </div>

        {/* Esposizione ottima */}
        <div className="p-4 border border-gray-200 rounded-lg">
          <Checkbox
            id="hasGoodExposure"
            checked={formData.hasGoodExposure || false}
            onChange={(e) => updateFormData({ hasGoodExposure: e.target.checked })}
            label="Esposizione ottima (sud, sud-ovest, luminosità)"
          />
        </div>

        {/* Spazi esterni */}
        <div className="p-4 border border-gray-200 rounded-lg">
          <Checkbox
            id="hasExternalSpaces"
            checked={formData.hasExternalSpaces || false}
            onChange={(e) => updateFormData({ hasExternalSpaces: e.target.checked })}
            label="Spazi esterni (terrazzo, balcone, giardino)"
          />
        </div>

        {/* Garage */}
        <div className="p-4 border border-gray-200 rounded-lg space-y-4">
          <Checkbox
            id="hasGarage"
            checked={formData.hasGarage || false}
            onChange={(e) => updateFormData({ hasGarage: e.target.checked })}
            label="Box / Posto auto"
          />
          {formData.hasGarage && (
            <div className="ml-6">
              <Label htmlFor="garageType">Tipo</Label>
              <Select
                id="garageType"
                value={formData.garageType || 'box'}
                onChange={(e) => updateFormData({ garageType: e.target.value })}
                options={garageOptions}
                className="max-w-[200px]"
              />
            </div>
          )}
        </div>

        {/* Altri servizi */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 border border-gray-200 rounded-lg">
            <Checkbox
              id="hasPool"
              checked={formData.hasPool || false}
              onChange={(e) => updateFormData({ hasPool: e.target.checked })}
              label="Piscina"
            />
          </div>

          <div className="p-4 border border-gray-200 rounded-lg">
            <Checkbox
              id="isResidence"
              checked={formData.isResidence || false}
              onChange={(e) => updateFormData({ isResidence: e.target.checked })}
              label="In residence / Condominio con servizi"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
